import LayoutUtils from 'src/utils/layout_utils';

/**
 * Toggle popup top mode: readonly, edit, or time.
 * callbacks: { initInlineEditListingAutocomplete(popup) } for side effects after switching to edit/time.
 */
export function toggleTopMode(popup, mode, callbacks = {}) {
  if (!popup) {
    return;
  }

  const readonlyWrap = popup.querySelector('.js-showing-view-readonly');
  const editWrap = popup.querySelector('.js-showing-view-edit-inline');
  const timeWrap = popup.querySelector('.js-showing-view-time-inline');

  if (!readonlyWrap || !editWrap) {
    return;
  }

  const isEditMode = mode === 'edit' || mode === 'time';
  LayoutUtils.toggle(readonlyWrap, !isEditMode);
  LayoutUtils.toggle(editWrap, isEditMode);
  if (timeWrap) {
    LayoutUtils.hide(timeWrap);
  }

  popup.classList.toggle('showing-view-popup--editing', isEditMode);
  popup.classList.toggle('showing-view-popup--time-editing', false);

  if (mode === 'edit') {
    callbacks.initInlineEditListingAutocomplete?.(popup);
    const firstInput = editWrap.querySelector('.js-showing-view-edit-first-focusable');
    firstInput?.focus();
  } else if (mode === 'time') {
    const selectedSlot = timeWrap.querySelector('.js-showing-view-time-slot--selected');
    if (selectedSlot) {
      selectedSlot.focus();
    } else {
      timeWrap.querySelector('.js-showing-view-time-day-toggle')?.focus();
    }
  }
}
